import React from "react";
import { SERVICES } from "../data/mock";

export const Services = () => {
  return (
    <section
      id="practice"
      data-testid="services-section"
      className="py-24 lg:py-32 bg-cream relative"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="gold-line" />
              <span className="text-xs tracking-[0.3em] uppercase text-navy/70 font-medium">
                What We Handle
              </span>
            </div>
            <h2
              data-testid="services-headline"
              className="font-serif text-4xl sm:text-5xl lg:text-6xl text-navy leading-[1.05] tracking-tight"
            >
              Practice rooted in
              <br />
              <span className="italic text-gold">financial</span> precision.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p
              data-testid="services-description"
              className="text-base lg:text-lg text-navy/75 leading-relaxed"
            >
              The Bufkin Law Firm represents clients in business, family-law
              and probate litigation where financial issues drive the
              outcome — and provides expert witness services to other
              attorneys whose cases demand a deeper command of the numbers.
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#C0974E]/15 border border-[#C0974E]/15 rounded-sm overflow-hidden">
          {SERVICES.map((service, idx) => {
            const Icon = service.icon;
            return (
              <div
                key={service.title}
                data-testid={`service-card-${idx}`}
                className="service-card p-8 lg:p-10 group cursor-default"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-12 h-12 rounded-sm bg-navy/5 flex items-center justify-center group-hover:bg-navy group-hover:text-ivory transition-all duration-500">
                    <Icon
                      className="w-5 h-5 text-navy group-hover:text-gold transition-colors duration-500"
                      strokeWidth={1.5}
                    />
                  </div>
                  <span className="font-serif text-3xl text-gold/40">
                    0{idx + 1}
                  </span>
                </div>

                <h3
                  className="font-serif text-2xl text-navy mb-3 leading-tight"
                  data-testid={`service-title-${idx}`}
                >
                  {service.title}
                </h3>
                <p className="text-sm text-navy/70 leading-relaxed mb-5">
                  {service.description}
                </p>

                <ul className="space-y-2 pt-4 border-t border-[#C0974E]/20">
                  {service.items.map((item) => (
                    <li
                      key={item}
                      className="text-xs uppercase tracking-wider text-navy/60 flex items-center gap-2"
                    >
                      <span className="w-1 h-1 rounded-full bg-gold" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
